module.exports = __webpack_public_path__ + "static/media/rooms-ch4.bea4a165.png";